import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const currentPageSlice = createSlice({
    name: 'currentPage',
    initialState: '',
    reducers: {
        setCurrentPage: (state, action) => {
            return action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return '';
        });
    }
});

export const { setCurrentPage } = currentPageSlice.actions;

export const selectCurrentPage = (state) => state.currentPage;

export default currentPageSlice.reducer;
